import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom"
import { level3, secondaryNavigation } from "../../models/primary-menu-model";


const DropdoenMenu = (props:{mits: level3[]}) => {
    return <div className="dropdown-content" >  
    {
       props.mits.map((item, index) => {
        return <Nav.Link href={item.page} key={index}><span>{item.name}</span></Nav.Link>
       })
    }

            </div>
}

export default DropdoenMenu;